import {createFileRoute} from '@tanstack/react-router';

type PaymentMethod = 'OPEN_BANKING' | 'CONNECTED_ACCOUNT';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/_payment',
)({
  validateSearch: (search): {method: PaymentMethod} => {
    return {
      method: search.method as PaymentMethod,
    };
  },
});
